import { useCallback, useRef } from 'react';
import { useSceneState, useSceneActions } from '../../presentation/providers/SceneProvider';

import { TOTAL_FRAMES } from '../../domain/constants';

export function useFrameNav() {
  const { currentFrameId, currentFrame, isLoading, error } = useSceneState();
  const { navigateTo } = useSceneActions();
  const frameIdRef = useRef(currentFrameId);
  frameIdRef.current = currentFrameId;

  const goTo = useCallback((frameId: number) => {
    navigateTo(frameId);
  }, [navigateTo]);

  const next = useCallback(() => {
    const target = Math.min(TOTAL_FRAMES - 1, frameIdRef.current + 1);
    frameIdRef.current = target;
    navigateTo(target);
  }, [navigateTo]);

  const prev = useCallback(() => {
    const target = Math.max(0, frameIdRef.current - 1);
    frameIdRef.current = target;
    navigateTo(target);
  }, [navigateTo]);

  return { currentFrameId, currentFrame, isLoading, error, goTo, next, prev };
}
